import type { DriverSession } from '@/api/types'
import { npr } from '@/lib/format'
import { useI18n } from '@/lib/i18n'

/** Only the backend ledger can tell us what was collected; never infer it from cost. */
export function ReceiptPayment({ s }: { s: DriverSession }) {
  const { t } = useI18n()
  const paid = s.amount_paid ?? s.cost_breakdown?.amount_paid
  const outstanding = s.outstanding_amount ?? s.cost_breakdown?.outstanding_amount
  return <>
    {paid != null && <p className="mt-3 flex justify-between gap-3 text-sm"><span className="text-text-2">{t('Amount collected')}</span><span className="tabular font-semibold">{npr(paid)}</span></p>}
    {outstanding != null && outstanding > 0 && <p className="mt-3 rounded-lg bg-warning-soft p-2.5 text-[13px] text-warning">{t('Outstanding amount: {amount}', { amount: npr(outstanding) })}</p>}
  </>
}
